/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface StatusCardProps {
  label: string;
  value: string | number;
  color: string;
  trend: string;
}

const BatchStatusCard: React.FC<StatusCardProps> = ({
  label,
  value,
  color,
  trend,
}) => {

  return (
    <div
      style={{ borderTopColor: color }}
      className={`bg-white p-1 rounded-xl
      h-[95px]
      border-t-[5px] border-solid
      border-l border-r-0 border-b-0 border-slate-100
      shadow-sm flex flex-col justify-between text-left`}
    >
      <div className="flex justify-between items-start">
        <p className="text-[9px] font-black text-slate-300 uppercase tracking-[0.2em] mt-[3px] ml-[16px]">
          {label}
        </p>
      </div>

      <p className="text-xl font-black text-slate-800 -mt-[6px] ml-[16px]">{value}</p>

      <p className="text-[8px] font-black text-slate-300 uppercase -mt-[8px] ml-[16px] italic tracking-[0.1em]">
        {trend}
      </p>
    </div>
  );
};

export default BatchStatusCard;